import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {useSelector} from 'react-redux';
import {useMemo} from 'react';
import {RootState} from '../../../../../redux/store';
import {ReactComponent as SpeedTestIcon} from '../../../../../assests/svg/speed-test-icon.svg';
import {Link} from 'react-router-dom';
import {SPEED_TEST_URL} from '../../../../../constants/constants';

interface ReviewItem {
  id: string;
  label: string;
  value?: React.ReactNode;
}

interface ReviewDetailsGridProps {
  items: ReviewItem[];
}

interface EvidenceSourceInfoProps {
  showSpeedTest?: boolean;
}

const EvidenceSourceInfo: React.FC<EvidenceSourceInfoProps> = ({
  showSpeedTest = false,
}) => {
  const sourceDetails = useSelector(
    (state: RootState) => state.uploadEvidenceSource?.sourceDetails
  );

  const selectedProject = useSelector(
    (state: RootState) => state.uploadEvidenceSource.selectedProject
  );

  const reviewData: ReviewItem[] = useMemo(() => {
    if (!sourceDetails) return [];

    return [
      {
        id: 'evidenceName',
        label: t('reviewEvidenceSource.evidenceSourceName'),
        value: sourceDetails.evidenceName || '',
      },

      {
        id: 'referenceNumber',
        label: t('reviewEvidenceSource.referenceNumber'),
        value: sourceDetails.clientReference || '',
      },
    ];
  }, [sourceDetails]);

  const ReviewReviewItem = ({items}: ReviewDetailsGridProps) => {
    return (
      <Box className="review-evidence-upload-details">
        {items.map((item, index) => (
          <Box
            key={`${index.toString() + item.label}`}
            className="review-row-data"
            tabIndex={0}
          >
            <Typography className="typo-text subhead4_size custom-text-body-subtle">
              {item.label}
            </Typography>
            <Typography className="typo-text subhead2_size custom-header">
              {item.value || t('common.none')}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box className={'evidence-source-info'}>
      {showSpeedTest && (
        <Box className={'evidence-source-speed-test'}>
          <SpeedTestIcon className="speed-test-icon" />
          <Typography
            className="typo-text body4_size custom-text-color"
            tabIndex={0}
          >
            {t('evidenceSource.speedTest')}
            <Link
              data-testid="speed-test-link"
              to={SPEED_TEST_URL}
              target="_blank"
              className="typo-text body4_size speed-test-link"
            >
              {t('evidenceSource.runSpeedTest')}
            </Link>
          </Typography>
        </Box>
      )}
      <Typography
        className="typo-text display3_size custom-header"
        tabIndex={0}
      >
        {selectedProject?.projectName}
      </Typography>
      <ReviewReviewItem items={reviewData} />
    </Box>
  );
};

export {EvidenceSourceInfo};
